(function () {
  function watchMedia(query, callback) {
    if (query.addEventListener) {
      query.addEventListener('change', callback);
    } else if (query.addListener) {
      query.addListener(callback);
    }
  }

  function initializeReviews(root) {
    var sections = [];

    if (root.matches && root.matches('[data-ik-reviews]')) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections = sections.concat(Array.prototype.slice.call(root.querySelectorAll('[data-ik-reviews]')));
    }

    sections.forEach(function (section) {
      if (section.dataset.ikReviewsReady === 'true') return;

      var toggle = section.querySelector('[data-ik-reviews-toggle]');
      var label = section.querySelector('[data-ik-reviews-toggle-label]');
      var pauseIcon = section.querySelector('[data-ik-reviews-pause-icon]');
      var playIcon = section.querySelector('[data-ik-reviews-play-icon]');
      var shouldAutoplay = section.dataset.autoplay === 'true';
      var mobileQuery = window.matchMedia('(max-width: 767px)');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var userPaused = false;

      function syncMotionState() {
        var duration = mobileQuery.matches
          ? section.dataset.durationMobile
          : section.dataset.durationDesktop;

        section.style.setProperty('--ik-review-duration', duration + 's');
        section.classList.toggle('is-animated', shouldAutoplay && !reducedMotion.matches);

        if (toggle) {
          toggle.hidden = !shouldAutoplay || reducedMotion.matches;
        }
      }

      function syncButton() {
        if (!toggle || !label) return;

        section.classList.toggle('is-user-paused', userPaused);
        toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        label.textContent = userPaused ? 'Play reviews' : 'Pause reviews';

        if (pauseIcon) pauseIcon.hidden = userPaused;
        if (playIcon) playIcon.hidden = !userPaused;
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          userPaused = !userPaused;
          syncButton();
        });
      }

      watchMedia(mobileQuery, syncMotionState);
      watchMedia(reducedMotion, syncMotionState);
      syncMotionState();
      syncButton();
      section.dataset.ikReviewsReady = 'true';
    });
  }

  function start() {
    initializeReviews(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeReviews(event.target);
  });
})();
